import { useEffect, useState } from "react";
import { ICodename } from "./../../../commons/interfaces";

import { RoleHelpers } from "../../../commons/roleHelpers";
import { useCommonComponentContext } from "../../../providers/CommonComponentProvider";
import ServiceService from "../../../services/identity/service.service";

export const useSelectData = () => {
    const { userInfo } = useCommonComponentContext();
    const [services, setServices] = useState<ICodename[]>([]);

    const getAllService = async () => {
        try {
            if (!RoleHelpers.isServiceAdmin(userInfo?.userProfile?.roleType)) return;
            let listTemp: ICodename[] = [];

            const result = await ServiceService.getAll();

            result.forEach((e: any) => {
                listTemp.push({
                    code: e.serviceCode,
                    name: e.serviceName,
                });
            });

            setServices(listTemp);
        } catch (error) {}
    };

    useEffect(() => {
        getAllService();
    }, []);

    return {
        services,
    };
};

export default useSelectData;
